import styled from 'styled-components';
import { Popup } from '@fluentui/react';

export const RequestDetailsPopUpStyle = styled(Popup)`
  background: ${(props) => props.theme.popupOpacity};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
`;
